import React from "react";

import { Input } from "@components";
import { styles } from "@common/styles";
require("@common/styles/style.css");

export interface ILoginActions {
  login: (username, password) => void;
  routeToResetPassword: () => void;
}

export interface ILoginState {
  password: string;
  username: string;
}

class Login extends React.Component<ILoginActions, ILoginState> {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      username: ""
    };
  }

  public render() {
    return (
      <div>
        <div className="logoContainer" style={styles.logoContainer as any}>
          <img src="/images/logo.png" />
        </div>
        <div className="headerContainer" style={styles.headerContainer as any}>
          Logg inn
        </div>
        <div className="container" style={styles.container as any}>
          <form onSubmit={this.onLogin}>
            <Input
              name="username"
              label="Brukernavn"
              type="text"
              value={this.state.username}
              onChange={this.handleUsername}
              onKeyPress={this.handleEnterKeyPress}
            />
            <Input
              name="password"
              label="Passord"
              value={this.state.password}
              type="password"
              onChange={this.handlePassword}
              onKeyPress={this.handleEnterKeyPress}
            />
            <button
              className="loginBtn"
              ref="loginBtn"
              type="submit"
              style={styles.navButton as any}
            >
              Logg inn
            </button>
          </form>
          <div
            className="link"
            style={styles.linkStyle}
            onClick={this.props.routeToResetPassword}
            title="Glemt passord?"
          >
            Glemt passord?
          </div>
        </div>
      </div>
    );
  }

  private handleEnterKeyPress = e => {
    if (e.charCode === 13) {
      this.onLogin(e);
    }
  };

  private handleUsername = username => {
    this.setState({ username });
  };

  private handlePassword = password => {
    this.setState({ password });
  };

  private onLogin = event => {
    event.preventDefault();
    this.props.login(this.state.username, this.state.password);
  };
}

export default Login;
